import { render, staticRenderFns } from "./FormPlano.vue?vue&type=template&id=0af4553c&"
import script from "./FormPlano.vue?vue&type=script&lang=js&"
export * from "./FormPlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports